import React from 'react';
import { Button, Form, FormGroup, Label, Input} from 'reactstrap';
// import { Input } from '@progress/kendo-react-inputs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { login } from '../../../../Redux/Actions/EndUser/AuthActions';
import { resetInitialPassword } from '../../../../Redux/Actions/CommonActions';
import './LoginMenu.scss';

class LoginMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            submitted: false,
            error: ''
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

  handleInputChange(event) {
    const target = event.target;
    this.setState({ [target.name]: target.value });
  }

  handleSubmit(e) {
        e.preventDefault();
        this.setState({ submitted: true });
        const { email, password } = this.state;
        const { dispatch } = this.props;
        if (email && password) {
            dispatch(login(email, password));
        }
    }

    resetClicked() {
        this.props.resetInitialPassword();
        this.props.toggle();
    }

  componentDidUpdate(prevProps, prevState) {
      if (prevProps.loginError !== this.props.loginError){
        this.setState({error: this.props.loginError});
      }

      if (this.props.authenticated) {
          this.props.toggle();
      }
  }

    render (){
        return (
            <div className="d-flex flex-column login-modal">
                <Form onSubmit={this.handleSubmit}>
                    <FormGroup>
                        <Label htmlFor="memberEmail"><FontAwesomeIcon icon="envelope" /></Label>
                        <Input 
                        type="email" 
                        name="email" 
                        id="exampleEmail" 
                        placeholder="Enter Email Address" 
                        required={true}
                        value={this.state.email} 
                        onChange={this.handleInputChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label htmlFor="memberPassword"><FontAwesomeIcon icon="lock" /></Label>
                        <Input 
                        type="password" 
                        name="password" 
                        id="password" 
                        required={true}
                        placeholder="Enter Password" 
                        value={this.state.password} 
                        onChange={this.handleInputChange} />
                    </FormGroup>
                    <div className="btn-container">
                        <Button className="btnPrimary"  type="submit" >Login</Button>
                        <Button className="btnSecondary" onClick={this.props.toggle}>Cancel</Button>
                    </div>
                    <div className="forgot-password-container">
                        <div className="d-flexX flex-rowX justify-content-endX forgot-password">
                            <p className="text-danger mb-0 mr-2">{this.state.error ? this.state.error: null}</p> 
                            <Button color="link" tag={RouterNavLink} to="/resetpassword" size="xs" onClick={this.resetClicked}>Did you forget your password?</Button>
                        </div>
                    </div>
                </Form>
            </div>

        )
    }

}

function mapStateToProps(state) {
    const { authenticating, loginError, authenticated } = state.authentication;
    return {
        authenticating,
        authenticated,
        loginError
    };
}

const connectedLoginMenu = connect(mapStateToProps)(LoginMenu);
export { connectedLoginMenu as LoginMenu }; 